/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.joinCommunity'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  space: /*#__PURE__*/ l.string(),
  inviteToken: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 256 }),
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  space: /*#__PURE__*/ l.string(),
  state: /*#__PURE__*/ l.string<{
    knownValues: ['requested', 'approved', 'denied', 'removed', 'banned']
  }>(),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Join or request membership in a community. Private and invite-only communities require a one-time invite token. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
